import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Loader } from '@playbookux/playbook-web-core';
import { useMutation } from '@apollo/client';
import _ from 'lodash';
import { InputGroup, InputRemovedReason, TextLabel } from './styles';
import { UPDATE_REMOVED_REASON_TEST_SESSION } from './graphql';

const RemovedReason = ({
  testSessionId,
  testerRemovedReason,
  refetch,
}) => {
  const [removedReason, setRemovedReason] = useState(testerRemovedReason || '');
  const [
    updateRemovedReason,
    { loading: loadingRemovedReason },
  ] = useMutation(UPDATE_REMOVED_REASON_TEST_SESSION, {
    onCompleted: refetch,
  });

  const debouncedRemovedReason = useCallback(_.debounce(
    async (id, value) => {
      await updateRemovedReason({
        variables: {
          id,
          removedReason: value,
        },
      });
    }, [500],
  ), []);

  const handleChangeRemovedReason = (value, id) => {
    setRemovedReason(value);
    debouncedRemovedReason(id, value);
  };

  return (
    <>
      <InputGroup>
        <TextLabel as="label" htmlFor="removed-reason">Removed Reason</TextLabel>
        <InputRemovedReason
          id="removedReason"
          name="removedReason"
          placeholder="Please enter a reason we are replacing"
          onChange={(e) => handleChangeRemovedReason(e.target.value, testSessionId)}
          value={removedReason}
        />
      </InputGroup>
      {loadingRemovedReason && (
        <Loader size="small" data-loader="removed-reason-loader" />
      )}
    </>
  );
};

RemovedReason.defaultProps = {
  testerRemovedReason: '',
};

RemovedReason.propTypes = {
  testSessionId: PropTypes.string.isRequired,
  testerRemovedReason: PropTypes.string,
  refetch: PropTypes.func.isRequired,
};

export default RemovedReason;
